import Keycloak from "keycloak-js";
import { VARCONFIG } from "./varconfig";

export const keycloak = new Keycloak({
  url: VARCONFIG.KC_URL,
  realm: VARCONFIG.KC_REALM,
  clientId: VARCONFIG.KC_CLIENT_ID,
});

/*
export const initKeycloak = async () => {
  const authenticated = await keycloak.init({
    onLoad: "login-required",
    pkceMethod: "S256",
    checkLoginIframe: false, // fixes your iframe timeout issue
  });

  setInterval(() => {
    keycloak.updateToken(30).catch(() => {});
  }, 20_000);

  return authenticated;
};
*/

export const initKeycloak = async () => {
  try {
    const authenticated = await keycloak.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      checkLoginIframe: false, // fixes your iframe timeout issue
    });

    setInterval(() => {
      keycloak.updateToken(30).catch(() => {});
    }, 20_000);

    return authenticated;
  } catch (err) {
    console.error("Keycloak init failed:", err);
    throw err; // keep failing fast so you notice misconfig
  }
};

export const getToken = () => keycloak.token;
